module.exports = __webpack_public_path__ + "img/yxkpro_android.98f7bb6e.png";